module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_49-7d1063ddfc43de16664beb4b6a341062.png";